import ProjectContextBadge from '../components/layout/ProjectContextBadge';

export default function ComingSoon({ title, description, icon = '◐' }) {
  return (
    <div>
      <ProjectContextBadge />
      <div className="flex flex-col items-center justify-center text-center py-24 px-6">
        <div
          className="w-16 h-16 rounded-2xl flex items-center justify-center text-[28px] mb-5"
          style={{ backgroundColor: '#E6F4F2', color: '#0C9488' }}
        >
          {icon}
        </div>
        <h1 className="text-[22px] font-bold text-gray-900 mb-2">{title}</h1>
        <p className="text-[13.5px] text-gray-500 max-w-md leading-relaxed">
          {description}
        </p>
        <span className="mt-5 inline-flex items-center gap-1.5 text-[10.5px] font-semibold px-2.5 py-1 rounded-full bg-amber-50 text-amber-700 tracking-wide">
          DEMNÄCHST VERFÜGBAR
        </span>
      </div>
    </div>
  );
}
